import api from '../services/api';
import { API_BASE_URL } from './endpoints';

export { API_BASE_URL }; // Re-export for any legacy imports might still rely on this file

/**
 * Helper: builds default headers for every request
 * (Keeping for backward compatibility, but api.js interceptor is preferred)
 */
export const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'ngrok-skip-browser-warning': 'true',
    };
};

/**
 * Helper: GET request
 */
export const apiGet = async (path, config = {}) => {
    return api.get(path, config);
};

/**
 * Helper: POST request
 */
export const apiPost = async (path, body, config = {}) => {
    return api.post(path, body, config);
};

/**
 * Helper: PATCH request
 */
export const apiPatch = async (path, body, config = {}) => {
    return api.patch(path, body, config);
};

/**
 * Helper: PUT request
 */
export const apiPut = async (path, body, config = {}) => {
    return api.put(path, body, config);
};

/**
 * Helper: DELETE request
 */
export const apiDelete = async (path, config = {}) => {
    return api.delete(path, config);
};
